import React from 'react';
export function Footer() {
  return <footer className="w-full bg-cream" data-id="element-170" data-mp="19j53j40hsmi0">
      <div className="mx-auto w-full max-w-3xl px-5 pb-28 pt-12 text-center sm:px-8 sm:pb-32" data-id="element-171" data-mp="207t42eta1vo7">
        <p className="font-display text-lg font-black tracking-tight text-plum-deep" data-id="element-172" data-mp="2f4toryd1wqd6">Dr. Karito</p>
        <p className="mx-auto mt-4 max-w-2xl text-[12.5px] leading-relaxed text-ink/55 sm:text-[13.5px]" data-id="element-173" data-mp="2a5qp6tfubccl">
          Il Progetto Clinico della Menopausa™ è una risorsa educativa destinata ai professionisti
          sanitari abilitati. Non sostituisce il giudizio clinico, le normative locali o la cura
          personalizzata della paziente.
        </p>
        <p className="mt-5 text-[12px] font-medium text-ink/40" data-id="element-174" data-mp="1w7ilm2oatcsg">
          © 2026 Dr. Karito. Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}